import { useQuery } from "@tanstack/react-query";
import { callLcosService } from "../../data/lcosServices";
import { useAccessControl } from "../../app/use-access-control";
import { useAccessToken } from "../use-access-token";
import { FamilyMembers } from "./types";

export const familyMemberQueryKeys = {
  base: ["familyMembers"],
  detail: (centerId?: string, familyId?: string | null) => [...familyMemberQueryKeys.base, centerId, familyId] as const
} as const;

export const useFamilyMembers = (familyId?: string | null) => {
  const { getToken } = useAccessToken();
  const { activeCenterId } = useAccessControl();

  const query = useQuery({
    queryKey: familyMemberQueryKeys.detail(activeCenterId, familyId),
    enabled: !!activeCenterId && !!familyId,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: async () => getFamilyMembers(await getToken(), familyId!, activeCenterId!)
  });

  return query;
};

export const getFamilyMembers = (accessToken: string, familyId: string, centerId: string) => {
  return callLcosService<FamilyMembers>(
    accessToken,
    `/api/centers/${centerId}/families/contacts?family_id=${encodeURIComponent(familyId)}`,
    "GET"
  );
};
